import type {GetExamsDates} from 'domain/usecases';
import {RemoteGetExamsDates} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';

export const makeGetExamsDates = (): GetExamsDates => {
	const isExamsGracePeriodV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_GRACE_PERIOD_V3,
	);

	const endpoint = isExamsGracePeriodV3Enabled
		? BookingFlowEndPoints.examDatesV3
		: BookingFlowEndPoints.examDates;

	return new RemoteGetExamsDates(makeBFFApiUrl(endpoint), makeAuthorizeHttpClientDecorator());
};
